import React from 'react'

export default class HolidayManagementColumnModel {
  static HolidayManagementColumn = [
    {
      title: 'ID',
      field: 'id',
      hidden: true,
      defaultSort: 'asc'
    },
    {
      title: 'Holiday Name',
      align: 'left',
      field: 'holidayName'
    },
    {
      title: 'Holiday Date',
      align: 'left',
      field: 'holidayDate1',
      sorting: false,
      render: (rowData: any) => {
        // Use holidayDate1 if available (from mappingRenderData), otherwise fall back to holidayDate
        const dateValue = rowData.holidayDate1 || rowData.holidayDate
        if (!dateValue) return ''

        // Handle both Date objects and strings
        let date: Date
        if (dateValue instanceof Date) {
          date = dateValue
        } else if (typeof dateValue === 'string') {
          // Handle dd/mm/yyyy format
          const parts = dateValue.split('/')
          if (parts.length === 3) {
            date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
          } else {
            // Try ISO date format or other formats
            date = new Date(dateValue)
          }
        } else {
          // Try to convert to Date
          date = new Date(dateValue)
        }
        // Check if date is valid
        if (isNaN(date.getTime())) return ''
        // Display date in DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        return `${day}/${month}/${year}`
      }
    },
    {
      title: 'Year',
      align: 'left',
      field: 'year',
      editable: 'never',
      render: (rowData: any) => rowData.year || ''
    }
  ]
}
